import { classNames } from "src/helpers/classNames";

export default function DomoEmbedPlatform({ content }) {
  return (
    <>
      <div className={classNames("relative h-full w-full select-none")}>
        {content && (
          <div className="mx-auto h-full w-full select-none overflow-auto">
            <iframe
              id="iframe"
              title="Domo Embed"
              src={content?.embedUrl}
              width="100%"
              height="100%"
              allowFullScreen
              allow="fullscreen"
            />
          </div>
        )}
      </div>
    </>
  );
}
